import ArchiveIcon from '@material-design-icons/svg/filled/archive.svg?react';
import CheckIcon from '@material-design-icons/svg/filled/check.svg?react';
import { Fragment } from 'react';

import { cn } from '../../../lib/utils';
import { SPOTLIGHT_LIFECYCLE } from '../statusConfig';
import type { SpotlightStatus } from '../types';

const ORDER: Record<SpotlightStatus, number> = {
  draft: 0,
  published: 1,
  archived: 2,
};

export function LifecycleStepper({
  status,
}: {
  status: SpotlightStatus | null;
}) {
  if (status === 'archived') {
    return (
      <div className="flex items-center gap-1.5 text-xs font-medium text-neutral-400">
        <ArchiveIcon className="size-4 fill-current" />
        Archived
      </div>
    );
  }

  const currentIndex = status ? ORDER[status] : -1;

  return (
    <div className="flex items-center">
      {SPOTLIGHT_LIFECYCLE.map((step, index) => {
        const isDone = index < currentIndex;
        const isActive = index === currentIndex;
        return (
          <Fragment key={step.key}>
            <div className="flex items-center gap-1.5">
              <span
                className={cn(
                  'flex size-5 items-center justify-center rounded-full border text-[10px] font-semibold tabular-nums',
                  isDone && 'border-teal-500 bg-teal-500 text-neutral-950',
                  isActive && 'border-teal-500 text-teal-400',
                  !isDone && !isActive && 'border-neutral-700 text-neutral-600',
                )}
              >
                {isDone ? (
                  <CheckIcon className="size-3 fill-current" />
                ) : (
                  index + 1
                )}
              </span>
              <span
                className={cn(
                  'text-xs font-medium',
                  isActive
                    ? 'text-white'
                    : isDone
                      ? 'text-neutral-300'
                      : 'text-neutral-600',
                )}
              >
                {step.label}
              </span>
            </div>
            {index < SPOTLIGHT_LIFECYCLE.length - 1 && (
              <span
                className={cn(
                  'mx-2 h-px w-6',
                  index < currentIndex ? 'bg-teal-500/60' : 'bg-neutral-700',
                )}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
